import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function subVacationReducer() {
    return combineReducers({
        EmployeesVacation_ListSubForPO: createItemReducer("SubVacation", "ShedHolidayDetail.ListSubForNewPO", false),
        EmployeesVacation_ListSubForPOParams: createItemReducerParams("SubVacation", "ShedHolidayDetail.ListSubForNewPO")
    });
}